<template>
  <CContainer fluid>
    <Loading :active.sync="isLoading"></Loading>
      <CRow class="d-flex content-center align-items-center min-vh-100">
        <CCol lg="6" xl="4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Inergi</h1>
                  <h5>CCTV Management System</h5>
                  <p class="text-muted">Silahkan log in dengan akun Anda</p>
                  <CInput
                    autofocus
                    placeholder="Email"
                    v-model="email"
                    autocomplete="email"
                    maxlength="50"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="password"
                    autocomplete="current-password"
                    maxlength="50"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                    <!--<template #append-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>-->
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton @click="submit" type="submit" color="primary" class="px-4">Login</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
  </CContainer>
</template>
<script>
export default {
  name: 'Login',
  components: {
  },
  data(){
    return {
      isLoading: false,
      email: '',
      password: ''
    }
  },
  methods: {

    submit(event){
      event.preventDefault();
      // localStorage.setItem(this.$tokenKeyword, 'Bearer 123');
      // localStorage.setItem(this.$userIdKeyword, 1);
      // localStorage.setItem(this.$emailKeyword, "ivan@test.com");
      // localStorage.setItem(this.$roleIdKeyword, 1); // NOTE: Admin = 1
      // localStorage.setItem(this.$lockKeyKeyword, "asdf");
      // localStorage.setItem(this.$roleNameKeyword, response.data.data.role.name);

      // // set token for axios auth
      // this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem(this.$tokenKeyword);
      // this.$router.push('/demo');

      if (this.$helper.isEmpty(this.email) || this.$helper.isEmpty(this.password)) {
        this.$helper.toastError(this, "Login Gagal! Please enter email and password")
        return
      }

      // start login process
      this.isLoading = true;
      let processUrl = "/login";
      let data = {
        username: this.email.toLowerCase(),
        password: this.password,
      }
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          if (response.data.success){
            // set token clock timer directly after login
            // localStorage.setItem(this.$tokenClockKeyword, response.data.data.exp);
            // set other credentials
            localStorage.setItem(this.$tokenKeyword, 'Bearer ' + response.data.data.access_token);
            localStorage.setItem(this.$userIdKeyword, response.data.data.user_id);
            localStorage.setItem(this.$emailKeyword, response.data.data.email);
            localStorage.setItem(this.$roleIdKeyword, response.data.data.role); // NOTE: Admin = 1
            localStorage.setItem(this.$lockKeyKeyword, response.data.data.lockKey);
            // localStorage.setItem(this.$roleNameKeyword, response.data.data.role.name);
            // set token for axios auth
            this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem(this.$tokenKeyword);
            // finish login process and redirect to home (dashboard)
            this.isLoading = false;
            this.$router.push('/home');
          } else{
            this.$helper.toastError(this, "Login Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            this.password = ''
          }
        } else {
          this.$helper.toastError(this, "Login Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Login Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        } else{
          this.$helper.toastError(this, "Login Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      });
    },
  },
  mounted(){
    this.$axios.defaults.headers.common['Authorization'] = ""
    localStorage.removeItem(this.$tokenKeyword);
    // localStorage.removeItem(this.$tokenClockKeyword);
    localStorage.removeItem(this.$userIdKeyword);
    localStorage.removeItem(this.$emailKeyword);
    localStorage.removeItem(this.$roleIdKeyword);
    // localStorage.removeItem(this.$roleNameKeyword);
    localStorage.clear()
    sessionStorage.clear()
  }
}
</script>
